import React from 'react';
import styled from 'styled-components';
import smallLogo from '~/assets/images/small-logo.png';

const ContainerLoading = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  justify-content: center;
  align-items: center;
  background-color: #D38A27;
`;

const AnimatedLoading = styled.div`
  background-image: url(${smallLogo});
  background-repeat: no-repeat;
  background-position-x: 50%;
  background-position-y: 50%;
  height: 100px;
  width: 140px;

  transform: scale(1);
  animation: pulse 1300ms infinite;

  @keyframes pulse {
    0% {
      transform: scale(0.85);
    }

    70% {
      transform: scale(1);
    }

    100% {
      transform: scale(0.85);
    }
  }
`;

export default function AnimatedLoadingFull() {
  return (
    <ContainerLoading>
      <AnimatedLoading />
    </ContainerLoading>
  )
}
